<script>
import { DECISION_LOG_PANEL } from '~/work_items/constants';
import { getRequestedPanel } from '~/work_items/utils';
import DecisionLogInlineRow from './decision_log_inline_row.vue';
import DecisionLogPanel from './decision_log_panel.vue';

export default {
  name: 'WorkItemDecisionLog',
  components: {
    DecisionLogInlineRow,
    DecisionLogPanel,
  },
  props: {
    isInDrawer: {
      type: Boolean,
      required: true,
    },
    isPanelOpen: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['request-panel'],
  // The row has no control of its own yet, so the `?show=` param is the only way in. The panel
  // portal exists on the full page only, so the drawer takes no part in this.
  created() {
    if (this.isInDrawer) return;

    window.addEventListener('popstate', this.syncPanelFromUrl);
    if (getRequestedPanel() === DECISION_LOG_PANEL && !this.isPanelOpen) {
      this.$emit('request-panel', DECISION_LOG_PANEL);
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.syncPanelFromUrl);
  },
  methods: {
    // Sibling panels listen to the same event, and props update on the next tick, so a handler
    // that closed itself whenever the param was not its own would undo the panel that just
    // opened. Only act when the param names this panel, or names no panel at all.
    syncPanelFromUrl() {
      const requested = getRequestedPanel();

      if (requested === DECISION_LOG_PANEL && !this.isPanelOpen) {
        this.$emit('request-panel', DECISION_LOG_PANEL);
      } else if (!requested && this.isPanelOpen) {
        this.$emit('request-panel', null);
      }
    },
  },
};
</script>

<template>
  <div>
    <decision-log-inline-row />
    <decision-log-panel :open="isPanelOpen" @close="$emit('request-panel', null)" />
  </div>
</template>
